import { AmountFilter } from './AmountFilter';
import {
  type CalendarFilterDateType,
  type CheckInOutType,
  DateFilter,
} from './DateFilter';
import { FilterPill } from './FilterPill';
import { MonthFilter } from './MonthFilter';
import { SearchFilter } from './SearchFilter';
import { StatusFilter } from './StatusFilter';
import { YearFilter } from './YearFilter';

import { SelectFilter } from './SelectFilter';
export { useSelectQueryGate } from './useSelectQueryGate';

export type { CalendarFilterDateType, CheckInOutType };

export const Filter = {
  Search: SearchFilter,
  Select: SelectFilter,
  Date: DateFilter,
  Amount: AmountFilter,
  Month: MonthFilter,
  Year: YearFilter,
  Status: StatusFilter,
  Pill: FilterPill,
};

export * from './FilterPill';
